module.exports = __webpack_public_path__ + "static/media/shoppingCartICon_white.048064aa.svg";